import { render, staticRenderFns } from "./StdizerAppearanceSettings.vue?vue&type=template&id=3c0fff7d&scoped=true"
import script from "./StdizerAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./StdizerAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StdizerAppearanceSettings.vue?vue&type=style&index=0&id=3c0fff7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0fff7d",
  null
  
)

export default component.exports